"use strict";

var _toConsumableArray = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Emitter = require("wolfy87-eventemitter");

var disposable_1 = require("../disposable");

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this._emitter = new Emitter();
    this._registeredListeners = new Map();
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(type, listener) {
      var _this = this;

      var registeredListeners = this._registeredListeners.get(type);

      if (registeredListeners === void 0) {
        registeredListeners = new WeakSet();

        this._registeredListeners.set(type, registeredListeners);
      } else if (registeredListeners.has(listener)) {
        throw new Error("Double-registered for '".concat(type, "' event."));
      }

      var wrappedListener = function wrappedListener() {
        try {
          listener.apply(void 0, arguments);
        } catch (ex) {
          console.error(ex);
        }
      };

      registeredListeners.add(listener);

      this._emitter.on(String(type), wrappedListener);

      return disposable_1.createDisposable(function () {
        var _a;

        (_a = registeredListeners) === null || _a === void 0 ? void 0 : _a.delete(listener);

        _this._emitter.off(String(type), wrappedListener);
      });
    }
  }, {
    key: "emit",
    value: function emit(type) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this._emitter.trigger(String(type), args);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._registeredListeners.clear();

      this._emitter.removeAllListeners();
    }
  }, {
    key: "createEmitGroup",
    value: function createEmitGroup() {
      var notifier = this;
      var eventQueue = [];
      var flushed = false;
      return {
        get queueCount() {
          return eventQueue.length;
        },

        emit: function emit(event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          if (flushed) {
            notifier.emit.apply(notifier, [event].concat(args));
          } else {
            eventQueue.push([event, args]);
          }
        },
        flush: function flush() {
          var _iterator = _createForOfIteratorHelper(eventQueue),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _step$value = _slicedToArray(_step.value, 2),
                  event = _step$value[0],
                  args = _step$value[1];

              try {
                notifier.emit.apply(notifier, [event].concat(_toConsumableArray(args)));
              } catch (e) {}
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          this.reset();
          flushed = true;
        },
        reset: function reset() {
          eventQueue.length = 0;
          flushed = false;
        }
      };
    }
  }, {
    key: "hasListeners",
    get: function get() {
      var eventsToListeners = this._emitter.getListeners(/.*/);

      for (var ev in eventsToListeners) {
        if (!{}.hasOwnProperty.call(eventsToListeners, ev)) continue;
        var l = eventsToListeners[ev];

        if (l !== undefined && l.length > 0) {
          return true;
        }
      }

      return false;
    }
  }]);

  return EventEmitter;
}();

exports.EventEmitter = EventEmitter;